export function JobsFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/jobs-filled.svg'"></ng-include>`
    }
}